import { Modal, Box, Slide, Typography, Grid, Divider, useTheme, useMediaQuery } from "@mui/material"
import { BranchOrderItemRead } from "../../../../global/API";
import { useState, useEffect } from "react"
import CloseIcon from '@mui/icons-material/Close';

export const OrderDetails = ({ open, setOpen, orderDetails }) => {

    const [orderItems, setOrderItems] = useState([])

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

    const ReadBranchOrderItem = async () => {
        if (!orderDetails?.id) return
        const qsp = { order_id: orderDetails.id }
        const res = await BranchOrderItemRead(qsp)
        if (res) setOrderItems(res)
    }

    useEffect(() => {
        if (open) ReadBranchOrderItem()
        //eslint-disable-next-line
    }, [open])

    const formatDate = (date) => {
        const d = new Date(date)
        return d.toLocaleString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            hour12: true
        })
    }

    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <Slide in={open} direction="up">
                <Box
                    sx={{
                        width: isMobile ? "100%" : 600,
                        height: isMobile ? "100vh" : "auto",
                        bgcolor: "#fff",
                        py: 5,
                        px: 4,
                        mx: "auto",
                        mt: isMobile ? 0 : "10%",
                        borderRadius: isMobile ? 0 : 2,
                        overflowY: "auto",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                    }}
                >
                    <Box>
                        {/* HEADER */}
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            position: isMobile ? "sticky" : "static",
                            top: 0,
                            bgcolor: "#fff",
                            zIndex: 1,
                            pb: 1
                        }}>
                            <Typography variant={isMobile ? "subtitle1" : "h6"} fontWeight="bold">
                                Order Details
                            </Typography>
                            <CloseIcon onClick={() => setOpen(false)} sx={{ color: "red" }} />
                        </Box>

                        <Divider sx={{ my: 2 }} />

                        {/* ORDER INFO */}
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <b>Order No:</b> {orderDetails?.series_num}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <b>Branch:</b> {orderDetails?.name}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <b>Staff:</b> {orderDetails?.first_name} {orderDetails?.last_name}
                                </Typography>
                            </Grid>

                            <Grid item xs={12} sm={6}>
                                <Typography variant="body2">
                                    <b>Date:</b> {formatDate(orderDetails?.created_at)}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 2 }} />

                        {/* ITEMS HEADER */}
                        <Grid container sx={{ fontWeight: "bold", mb: 1 }}>
                            <Grid item xs={6}>Product</Grid>
                            <Grid item xs={3}>Qty</Grid>
                            <Grid item xs={3} textAlign="right">Amount</Grid>
                        </Grid>

                        {/* ITEMS */}
                        {orderItems.map((item) => (
                            <Grid container key={item.id} sx={{ mb: 1 }}>
                                <Grid item xs={6}>
                                    {item.product_name}
                                </Grid>

                                <Grid item xs={3}>
                                    {item.quantity}
                                </Grid>

                                <Grid item xs={3} textAlign="right">
                                    ₱{item.amount}
                                </Grid>
                            </Grid>
                        ))}
                    </Box>
                    <Box>
                        <Divider sx={{ my: 2 }} />

                        {/* TOTALS */}
                        <Grid container>
                            <Grid item xs={8}>
                                <Typography fontWeight="bold">Total Sales</Typography>
                            </Grid>
                            <Grid item xs={4} textAlign="right">
                                <Typography fontWeight="bold">
                                    ₱{orderDetails?.total_sales || 0.00}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Grid container>
                            <Grid item xs={8}>
                                <Typography fontWeight="bold">Cash Received</Typography>
                            </Grid>
                            <Grid item xs={4} textAlign="right">
                                <Typography fontWeight="bold">
                                    ₱{orderDetails?.cash_received || 0.00}
                                </Typography>
                            </Grid>
                        </Grid>

                        <Divider sx={{ my: 2 }} />

                        <Grid container>
                            <Grid item xs={8}>
                                <Typography fontWeight="bold">Change</Typography>
                            </Grid>
                            <Grid item xs={4} textAlign="right">
                                <Typography fontWeight="bold">
                                    ₱{(parseFloat(orderDetails?.cash_received || 0) - parseFloat(orderDetails?.total_sales || 0)).toFixed(2)}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Slide>
        </Modal>
    )
}